import { render } from "./TimesheetSetting.vue?vue&type=template&id=fdfc0264&scoped=true"
import script from "./TimesheetSetting.vue?vue&type=script&lang=js"
export * from "./TimesheetSetting.vue?vue&type=script&lang=js"

import "./timesheet.scss?vue&type=style&index=0&id=fdfc0264&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfc0264"]])

export default __exports__